import { ConfigType } from '@caresend/types';
import { getKeyValidationErrors } from './validation.js';

const placeGroupProductValidationKeys = {
  bloodVolume: true,
  cptCodes: true,
  dropOffTimeHr: true,
  friendlyName: true,
  id: true,
  isCombinable: true,
  labCode: true,
  minBloodVolume: true,
  minVolume: true,
  placeGroupID: true,
  priceToCaresend: true,
  processing: true,
  sampleType: true,
  stabilityRTHr: true,
  stabilityRefrigeratedHr: true,
  standardTurnaround: true,
  statTurnaround: true,
  supplyID: true,
  volume: true
};
const productValidationKeys = {
  id: true,
  name: true,
  taskID: true
};
/**
 * Determine whether an object of type Partial<PlaceGroupProductConfig> meets
 * all requirements to be non-partial
 */

const isPlaceGroupProductConfigValid = productConfig => !getKeyValidationErrors(productConfig, placeGroupProductValidationKeys);
/**
 * Evaluate an object of type Draft<PlaceGroupProductConfig> with all
 * required properties to resolve a non-draft type
 */

const getValidatedPlaceGroupProductConfig = productConfig => {
  if (!isPlaceGroupProductConfigValid(productConfig)) {
    throw Error(`Product does not pass validation:
      ${getKeyValidationErrors(productConfig, placeGroupProductValidationKeys)}`);
  }

  return productConfig;
};
/**
 * Determine whether an object of type Partial<Product> meets
 * all requirements to be non-partial with ConfigType.PCR
 */

const isProductWithPCRConfig = product => product.configType === ConfigType.PCR;
/**
 * Determine whether an object of type Partial<Product> meets
 * all requirements to be non-partial with ConfigType.URINE
 */

const isProductWithUrineConfig = product => product.configType === ConfigType.URINE;
/**
 * Determine whether an object of type Partial<Product> meets
 * all requirements to be non-partial with ConfigType.TUBE
 */

const isProductWithTubeConfig = product => product.configType === ConfigType.TUBE;
/**
 * Determine whether an object of type Partial<Product> meets
 * all requirements to be non-partial
 */

const isProductValid = product => !getKeyValidationErrors(product, productValidationKeys);
/**
 * Evaluate an object of type Draft<Product> with all
 * required properties to resolve a non-draft type
 */

const getValidatedProduct = product => {
  if (!isProductValid(product)) {
    throw Error(`Product does not pass validation:
      ${getKeyValidationErrors(product, productValidationKeys)}`);
  }

  return product;
};

export { getValidatedPlaceGroupProductConfig, getValidatedProduct, isPlaceGroupProductConfigValid, isProductValid, isProductWithPCRConfig, isProductWithTubeConfig, isProductWithUrineConfig };
